import { Link } from "react-router-dom";

import type { BusinessInfo } from "../api/types";
import { useLanguage } from "../i18n/LanguageContext";
import { DAY_KEYS } from "../lib/hours";
import LangSwitch from "./LangSwitch";
import Logo from "./Logo";
import "./Footer.css";

export default function Footer({ business }: { business: BusinessInfo }) {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="site-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Logo tone="light" variant="lockup" height={96} />
            <p className="footer-tagline">{t("footerTagline")}</p>
          </div>

          <div className="footer-col">
            <p className="footer-heading">{t("hoursLabel")}</p>
            <ul className="footer-hours">
              {DAY_KEYS.map((day) => {
                const h = business.hours[day];
                return (
                  <li key={day}>
                    <span>{t(day)}</span>
                    <span className="nums">{h ? `${h.open} – ${h.close}` : t("closedLabel")}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="footer-col">
            <p className="footer-heading">{t("addressLabel")}</p>
            <address className="footer-address">
              {business.name}
              <br />
              {business.address}
              <br />
              {business.city}
            </address>
            <a className="footer-link" href={`tel:${business.phone.replace(/\s/g, "")}`}>
              {business.phone}
            </a>
            {business.email && (
              <a className="footer-link" href={`mailto:${business.email}`}>
                {business.email}
              </a>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-rights">
            © <span className="nums">{new Date().getFullYear()}</span> {business.name} · {t("footerRights")}
          </p>
          <nav className="footer-legal" aria-label="Legal">
            <Link to="/menu">{t("navMenu")}</Link>
            <Link to="/reserve">{t("navReserve")}</Link>
            <a href={business.instagram} target="_blank" rel="noreferrer">
              Instagram
            </a>
            <Link to="/impressum">{t("imprint")}</Link>
            <Link to="/datenschutz">{t("privacy")}</Link>
          </nav>
          <div className="footer-tools">
            <LangSwitch tone="light" />
            <Link to="/dashboard" className="footer-login">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                <rect x="4" y="11" width="16" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 0 1 8 0v4" />
              </svg>
              {t("teamLogin")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
